import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeCheckoutForm from './StripeCheckoutForm';

interface StripeProviderProps {
  publicKey: string;
  amount: number;
  onSuccess: (paymentIntentId: string) => void;
  onError: (error: any) => void;
}

const StripeProvider: React.FC<StripeProviderProps> = ({ publicKey, amount, onSuccess, onError }) => {
  const stripePromise = loadStripe(publicKey);

  return (
    <Elements stripe={stripePromise}>
      <StripeCheckoutForm 
        amount={amount} 
        onSuccess={onSuccess} 
        onError={onError} 
      />
    </Elements>
  );
};

export default StripeProvider;
